import React from 'react';

export default function EndNodeDetailsSidepanelContent(): JSX.Element {
  // TODO(BNCH-126759): Add support for rendering router node configuration to sidepanel
  return <div>Placeholder end node sidepanel content</div>;
}
